import { render, staticRenderFns } from "./statementReview.vue?vue&type=template&id=0880d1c8&scoped=true&"
import script from "./statementReview.vue?vue&type=script&lang=js&"
export * from "./statementReview.vue?vue&type=script&lang=js&"
import style0 from "./statementReview.vue?vue&type=style&index=0&id=0880d1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880d1c8",
  null
  
)

export default component.exports